module.exports = __webpack_public_path__ + "static/img/video1.a95eecd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/video1.jpg
// module id = T6Jy
// module chunks = 0